<script>
	import { onMount } from 'svelte'
	import Calendar from './components/Calendar.svelte'
	import moment from 'moment'
	import 'moment/locale/fr'
	import DOMPurify from 'dompurify'
	import marked from 'marked'
	import { init } from 'pell'
	import TurndownService from 'turndown'
	import axios from 'axios'

	const turndownService = new TurndownService()

	$:arrDesc = []

	const getHtmlFromMDElement = (md) => DOMPurify.sanitize(marked(md))

	
	moment.locale('fr')


	const _init_compose = (element, callback) => {
		init({
			element,
			defaultParagraphSeparator: 'p',
			actions: ['bold', 'italic'],
			onChange: html => {
				callback(html)
			}
		})
	}

	const saveMD = (shtmlEditor) => {
		return turndownService.turndown(shtmlEditor)
	}

	const setHtmlEditor = (html) => {
		document.getElementById('editor').content.innerHTML = html
	}


	const u_atob = (ascii) => {
		return Uint8Array.from(atob(ascii), c => c.charCodeAt(0));
	}

	const u_btoa = (buffer) => {
		let binary = [];
		let bytes = new Uint8Array(buffer);
		for (let i = 0, il = bytes.byteLength; i < il; i++) {
			binary.push(String.fromCharCode(bytes[i]));
		}
		return btoa(binary.join(''));
	}


	const encode = (str) => {
		return window.btoa(encodeURIComponent(str))
	}

	const decode = (str) => {
		return decodeURIComponent(window.atob(str))
	}


	const seteditor = (id, html, callback) => {
		const editorparent = document.querySelector('#'+id)
		editorparent.innerHTML = ""
		editorparent.insertAdjacentHTML(`beforeend`,html)
		_init_compose(editorparent, callback)
	}

	const handleSelect = (e) => {console.log(e.target)}

	const _init = () => {
		let arrallVariable = document.querySelectorAll("[data-compose]"),
			barbutton = document.querySelector("#id_btn_selector")
		arrallVariable.forEach(element=> {
			let button = document.createElement('button')
			button.addEventListener('click', handleSelect)
			button.innerText = element.dataset.compose
			button.dataset.form = element.dataset.form
			if(element.dataset.insert ) button.dataset.insert = element.dataset.insert
			barbutton.insertAdjacentElement(`beforeend`, button)
		})
	}
	onMount(()=>{
		try {
			let mem = localStorage.getItem('invoices_tmp')
			if(mem) {
				mem = JSON.parse(mem)
				invoicesave = mem
			}
		}
		catch(e){
			
		}
	})

	let editorstate = 0

	let invoicesave = {}
	invoicesave.templates = []
	invoicesave.invoices = []

	const handleNewFacture = () => {
		let invoiceplace = document.querySelector("#contentInvoice")
		invoiceplace.innerHTML = ``
		tmpaddress = ``
		visutable = false
		if(editorstate === 1){
			document.getElementById("unit").value = ``
			document.getElementById("qtte").value = ``
			document.querySelector("#desc .pell-content").innerHTML = ``
			document.querySelector("#address .pell-content").innerHTML = ``
		}
		indexSelected = 0
		newinvoicetmp = {}
		arrDesc = []
		editorstate = 1
		if(invoicesave.templates.length>0)setTimeout(startNewInvoiceSelector, 500)
	}

	const startNewInvoiceSelector = () => {
		seteditor("address", "", changeAddress)
		seteditor("desc", "", setDesc)
	}

	let tmpaddress = ``
	let tmpDesc = ``

	const changeAddress = (html) => {
		tmpaddress = html
		console.log(tmpaddress)
	}


	const setDesc = (html) => {
		tmpDesc = html
		console.log(tmpDesc)
	}

	const handleSave = () => {
		invoicesave.invoices.push(newinvoicetmp)
		localStorage.setItem('invoices_tmp', JSON.stringify(invoicesave))
	}

	const handleExport = () => {
		if(invoicesave.templates.length<1) {return alert("Attention, il n'y a rien à exporter")}
		download(JSON.stringify(invoicesave), `${moment().format('YYYYMMDDhhmmss')}_sauvegarde_invoices.json`, 'text/plain')
	}

	const handleImport = (json) => {
		if (json.templates) {
			invoicesave = json
			localStorage.setItem('invoices_tmp', JSON.stringify(invoicesave))
			alert("Votre fichier a bien été importé")
		} else {
			alert("Erreur!\nVotre fichier de sauvegarde ne correspond pas.")
		}
		console.log(json)
	}

	function download(content, fileName, contentType) {
		const a = document.createElement("a");
		const file = new Blob([content], { type: contentType });
		a.href = URL.createObjectURL(file);
		a.download = fileName;
		a.click();
	}

	let visutable = false
	const handleAddColl = () => {
		const 	unit = document.getElementById("unit"),
				qtte = document.getElementById("qtte"),
				unitv = parseFloat(unit.value).toFixed(2),
				qttev = parseFloat(qtte.value).toFixed(1),
				total = (unitv * qttev).toFixed(2)
		if(isNaN(unitv)) {
			unit.style.backgroundColor = "#F9EBEA"
			return
		}else {
			unit.style.backgroundColor = null
		}
		if(isNaN(qttev)) {
			qtte.style.backgroundColor = "#F9EBEA"
			return
		}else {
			qtte.style.backgroundColor = null
		}
		if(isNaN(total)) {
			unit.style.backgroundColor = "#F9EBEA"
			qtte.style.backgroundColor = "#F9EBEA"
			return
		}else {
			qtte.style.backgroundColor = null
			unit.style.backgroundColor = null
		}
		arrDesc.push({
			desc: tmpDesc,
			unit: unitv,
			qtte: qttev,
			total
		})
		unit.value = ``
		qtte.value = ``
		document.querySelector("#desc .pell-content").innerHTML = ``
		visutable = false
		console.log(arrDesc)
		setTimeout(redrawtable,250)
	}

	const changeInputValues = (desc, unit, qtte) => {
		document.getElementById("unit").value = unit
		document.getElementById("qtte").value = qtte
		document.querySelector("#desc .pell-content").innerHTML = desc
	}

	let indexSelected = 0

	const handleeditline = () => {
		indexSelected++
		if(indexSelected>(arrDesc.length - 1))indexSelected=0
		let elem = arrDesc[indexSelected]
		changeInputValues(elem.desc, elem.unit, elem.qtte)
	}
	
	const handledeleteline = () => {
		console.log("suppress line" + indexSelected)
		visutable = false
		arrDesc.splice(indexSelected, 1)
		setTimeout(redrawtable,250)
	}
	

	const redrawtable = () => {
		visutable = true
	}

	let newinvoicetmp = {}

	const handleSee = () => {
		console.log(invoicesave.templates[0].postsElements)
		console.log("visu")
		const 	no = document.getElementById("no"),
				date = document.getElementById("date"),
				name = document.getElementById("name").value,
				nov = no.value,
				datev = date.value
		let		indextpl = document.querySelector('input[name="tplchoice"]:checked').value
		if(!indextpl) indextpl = 0
				
		if(arrDesc.length < 1 ){return}
		if(nov==="") {
			no.style.backgroundColor = "#F9EBEA"
			return
		}else {
			no.style.backgroundColor = null
		}
		if(datev==="") {
			date.style.backgroundColor = "#F9EBEA"
			return
		}else {
			date.style.backgroundColor = null
		}
		let total = 0
		for(let i = 0; i < arrDesc.length; i++){
			total += parseFloat(arrDesc[i].total)
		}
		newinvoicetmp = {}
		let arrrows = []
		arrDesc.forEach(row=>{
			arrrows.push({
				desc: saveMD(row.desc),
				unit: parseFloat(row.unit),
				qtte: parseFloat(row.qtte),
				total: parseFloat(row.total)
			})
		})

		newinvoicetmp = {
			id: Date.now(),
			no: nov,
			date: moment(datev).format('YYYYMMDD'),
			name,
			address : saveMD(tmpaddress),
			rows: arrrows,
			total: total,
			indextpl,
			tpl_name: invoicesave.templates[indextpl].name
		}

		console.log(newinvoicetmp)

		populateInvoice()
	}

	const postELem = (desc, unit, qtte, total, template) => {
		template = 	template.replace('{{desc}}',desc)
		template = 	template.replace('{{unit}}',unit)
		template = 	template.replace('{{qtte}}',qtte)
		template = 	template.replace('{{total}}',total)
		return template
	}

	const populateInvoice = () => {
		let invoiceplace = document.querySelector("#contentInvoice"),
			invoiceHTML = invoicesave.templates[newinvoicetmp.indextpl].content
		invoiceHTML = invoiceHTML.replace("{{no}}", `${newinvoicetmp.date}_${newinvoicetmp.no}`)
		invoiceHTML = invoiceHTML.replace("{{date}}", `${moment(newinvoicetmp.date).format('LL')}`)
		invoiceHTML = invoiceHTML.replace("{{total}}", parseFloat(newinvoicetmp.total).toFixed(2))
		invoiceHTML = invoiceHTML.replace("{{address}}", getHtmlFromMDElement(newinvoicetmp.address))
		let rowshtml = ``
		for(let i = 0; i < newinvoicetmp.rows.length; i++){
			rowshtml += postELem(
				getHtmlFromMDElement(newinvoicetmp.rows[i].desc), 
				parseFloat(newinvoicetmp.rows[i].unit).toFixed(2), 
				parseFloat(newinvoicetmp.rows[i].qtte).toFixed(1), 
				parseFloat(newinvoicetmp.rows[i].total).toFixed(2),
				invoicesave.templates[newinvoicetmp.indextpl].postsElements
			)
			
		}
		invoiceHTML = invoiceHTML.replace("{{tablecontent}}", rowshtml)
		invoiceplace.innerHTML = ``
		invoiceplace.insertAdjacentHTML(`beforeend`, invoiceHTML)
		if(!document.getElementById("idbtnPrint")){
			const buttonImprime = document.createElement('button')
			buttonImprime.addEventListener("click", handlePrint)
			buttonImprime.setAttribute("id","idbtnPrint")
			buttonImprime.innerText = "Imprimer"
			document.body.insertAdjacentElement(`beforeend`, buttonImprime)
			const buttonCopieHTML = document.createElement('button')
			buttonCopieHTML.addEventListener("click", handleCP)
			buttonCopieHTML.setAttribute("id","idbtnPrint")
			buttonCopieHTML.innerText = "Enregistrer la facture à imprimer en pdf"
			document.body.insertAdjacentElement(`beforeend`, buttonCopieHTML)
		}
		editorstate = 3
	}

	const handlePrint = async () => {
		html2pdf()
		.set({
			filename: `facture_${newinvoicetmp.date}_${newinvoicetmp.no}_${newinvoicetmp.name}.pdf`,
			image:        { type: 'jpeg', quality: 1 },
			html2canvas: { scale: 4 },
			jsPDF: {orientation: 'portrait', unit: 'cm', format: 'a4', compressPDF: true}
		})
		.from(document.querySelector("#contentInvoice > div"))
		.save()
	}

	const copyToClipboard = str => {
		if (navigator && navigator.clipboard && navigator.clipboard.writeText)
			return navigator.clipboard.writeText(str);
		return Promise.reject('The Clipboard API is not available.');
	}

	const handleCP = () => {
		// if(typeof ClipboardItem === "undefined") {
    //     alert("Sorry! This feature is not yet available in the browser you are using.\n\n" +
    //         "Selecting the text and pasting it to your email should give you the same result.")
    //     return;
    // }
		const invoiceDiv = document.querySelector("#contentInvoice")
		// const type = "text/html";
    // const blob = new Blob([invoiceDiv.innerHTML], {type});
    // const data = [new ClipboardItem({[type]: blob})];
		// navigator.clipboard.write(data).then(function () {
		// 	invoiceDiv.style.opacity = '0.4';

    //     setTimeout(function () {
		// 			invoiceDiv.style.opacity = '1';
    //     }, 80)

    // }, function () {
    //     alert('Sorry, copy missed')
    // });
		// download(invoiceDiv.innerHTML, `facture_${newinvoicetmp.date}_${newinvoicetmp.no}_${newinvoicetmp.name}.txt`, 'text/plain')

		axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
		axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
		axios.defaults.withCredentials = true

		const html = `<html>
<head>
	<meta charset="utf-8">
	<meta name="viewport" content="width=device-width, initial-scale=1">
	<title></title>
	<style type="text/css">
		:root{font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif; font-size: 12px;}
		html, body {margin: 0; padding: 0;}
		body { font-family: }
	</style>
</head>
<body>
	<div style="position:relative;">
${invoiceDiv.innerHTML}
</div>
</body>
</html>`

		axios.post('https://printpdf.nshotech.at', {
			html
		}, {
			responseType: 'blob'
		})
		.then(response => {
			console.log(response.data)
			const file = new Blob([response.data], {type: 'application/pdf'})
			const fileURL = URL.createObjectURL(file);
			navigator.clipboard.writeText(`facture_${newinvoicetmp.date}_${newinvoicetmp.no}_${newinvoicetmp.name}.pdf`)
			.then(()=> {
				console.log(`facture_${newinvoicetmp.date}_${newinvoicetmp.no}_${newinvoicetmp.name}.pdf`, "\n is writed in clipboard\n")
			})
			.catch(()=> {
				console.warn(`facture_${newinvoicetmp.date}_${newinvoicetmp.no}_${newinvoicetmp.name}.pdf`, "\n is not writed in clipboard\n")
			})
			window.open(fileURL)
		})
		.catch(error=>console.warn({error}))
	}

	const loadFile = () => {
    var input, file, fr;

    if (typeof window.FileReader !== 'function') {
      alert("The file API isn't supported on this browser yet.");
      return;
    }

    input = document.getElementById('fileinput');
    if (!input) {
      alert("Um, couldn't find the fileinput element.");
    }
    else if (!input.files) {
      alert("This browser doesn't seem to support the `files` property of file inputs.");
    }
    else if (!input.files[0]) {
      alert("Please select a file before clicking 'Load'");
    }
    else {
      file = input.files[0];
      fr = new FileReader();
      fr.onload = receivedText;
      fr.readAsText(file);
    }

    function receivedText(e) {
			editorstate = 0
		let lines = e.target.result;
		var newArr = JSON.parse(lines); 
		handleImport(newArr)
		}
	}

	const handleaskImport = () => {
		editorstate = 10
	}

  	const handleInvoices = () => {
		editorstate = 30
		let tableelements = document.getElementById("visuinvoices")
		tableelements.innerHTML = ``
		invoicesave.invoices.forEach(inv=>{
			console.log(inv.name)
			tableelements.insertAdjacentHTML(`beforeend`,`<tr><td>${inv.name}</td><td>${moment(inv.date).format('LL')}</td><td>${inv.no}</td><td></td></tr>`)
		})
	}
	const handleImportDesign = () => {
		editorstate = 20
	}

	const loadTemplate = () => {
		let htmlcontent = document.getElementById("importtemplate").value,
			htmlrows = document.getElementById("importtemplatepostsElements").value,
			name = document.getElementById("importtemplatename").value

		invoicesave.templates.push({
			name,
			content: htmlcontent,
			postsElements: htmlrows
		})
		localStorage.setItem('invoices_tmp', JSON.stringify(invoicesave))
		editorstate = 0
	}

	const handleDeletAll = () => {
		invoicesave = {}
		invoicesave.templates = []
		invoicesave.invoices = []
		localStorage.setItem('invoices_tmp', JSON.stringify(invoicesave))
	}

	let bHidebtn2 = false
	
	const handleBtnVisuInvoice = () => {
		const index = document.querySelector('input[name="tplchoice"]:checked').value,
				displayer = document.querySelector("#contentInvoice")
		displayer.innerHTML = ``
		displayer.insertAdjacentHTML(`beforeend`, invoicesave.templates[index].content)
		bHidebtn2 = true
	}

	const handleHideBtnVisuInvoice = () => {
		bHidebtn2 = false
		document.querySelector("#contentInvoice").innerHTML = ``
		if(document.getElementById("idbtnPrint")) {
			document.getElementById("idbtnPrint").remove()
		}
	}

	const bAnnuleinvoicenew = () => {
		document.querySelector("#contentInvoice").innerHTML = ``
		editorstate = 0
	}
	const seeCalendar = () => {
		editorstate = 50
	}
</script>

<div class="container">
	<h1>Facture</h1>
	<hr>
	<table class="table" class:novisible={ editorstate !== 30 }>
		<tbody id="visuinvoices">
		</tbody>
	</table>
 	<fieldset class:novisible={ editorstate !== 20 }>
		<button on:click={()=>{editorstate = 0}}>Retour</button>
		<h2>Import de facture au format HTML</h2>
		<label for="name">Nom de la facture</label>
		<input type="text" class="form-control" id="importtemplatename" placeholder="P.E. FACTURE DE ....." style=" width: 80%; margin-bottom:1em;">
		<textarea class="form-control" id="importtemplate" rows="15" cols="80" placeholder="Entrez ici le template de la facture totale en format html" style="margin-bottom:1em;"></textarea>
		<textarea class="form-control" id="importtemplatepostsElements" rows="15" cols="80" placeholder="Entrez ici le template des lignes de tableau de la facture en format html" style="margin-bottom:1em;"></textarea>
		<input type='button' value='Ajouter' on:click={loadTemplate}>
	</fieldset>
	<form id="jsonFile" name="jsonFile" enctype="multipart/form-data" method="post" class:novisible={ editorstate !== 10}>
		<button on:click={()=>{editorstate = 0}}>Retour</button>
		<fieldset>
			<h2>Fichier de sauvegarde</h2>
			<input type='file' id='fileinput'>
			<input type='button' id='btnLoad' value='Lire' on:click={loadFile}>
		</fieldset>
	</form>
	{#if editorstate === 0 || editorstate === 3}
		<div class="split">
			<button on:click={seeCalendar}>Calendrier</button>
		</div>
		<div class="split">
			<button on:click={handleNewFacture}>Nouvelle facture</button>
			{#if invoicesave.invoices.length>0}
			<button on:click={handleInvoices}>Voir les factures</button>
			{/if}
		</div>
		<div class="split">
			<button on:click={handleaskImport}>Importer une sauvegarde</button>
			<button on:click={handleExport}>Exporter une sauvegarde</button>
		</div>
		<div class="split">
			<div></div><div></div><div></div><div></div>
			<button on:click={handleImportDesign}>Importer un design</button>
		</div>
		<div class="split">
			<div></div><div></div><div></div><div></div>
			<button on:click={handleDeletAll}>Effacer Tout</button>
		</div>
	{/if}
	{#if editorstate === 3}
	<div class="split">
	<button on:click={handleSave}>Sauvegarder</button>
	</div>
	<hr>
	{/if}

	<div>
		{#if editorstate === 1}
		{#if invoicesave.templates.length<1}
		<div class="alert alert-danger" role="alert">
			<h3>Il n'y a pas de templates enregistré</h3>
			<button on:click={()=>{editorstate = 20}}>Importer des données</button> ou <button on:click={handleImportDesign}>Importer un design</button>
		</div>
		{:else}
		<button on:click={bAnnuleinvoicenew}>Annuler</button>
		<div class="split">
			<div>
				<label for="name">Nom de la facture</label>
				<input type="text" class="form-control" id="name" placeholder="P.E. DUPONT">
			</div>
			<div>
				<label for="#">Type de template</label>
				{#each invoicesave.templates as tpl, index}
				<div class="form-check">
					<input class="form-check-input" type="radio" name="tplchoice" id="tplchoice_{index}" value="{index}">
					<label class="form-check-label" for="tplchoice_{index}">
						{tpl.name}
					</label>
				</div>
				{/each}
			</div>
		</div>
		<div class="split">
			<div></div><button on:click={handleBtnVisuInvoice} id="btnvisutpl">Visualiser l'exemple</button>
		</div>
		<div class="split" class:novisible={ !bHidebtn2 }>
			<div></div><button on:click={handleHideBtnVisuInvoice} id="btnvisutpl">Cacher l'exemple</button>
		</div>
		<div class="split">
			<div class="form-group">
				<label for="no">Numéro</label>
				<input type="number" class="form-control" id="no" placeholder="numéro">
			</div>	
			<div class="form-group">
				<label for="date">Date</label>
				<input type="date" class="form-control" id="date" placeholder="date">
			</div>
		</div>
		<div class="split">
			<div class="form-group">
				<label for="address">Destinataire</label>
				<div id="address"></div>
			</div>
		</div>
		<hr>
		<div class="form-group">
			<label for="desc">Description</label>
			<div id="desc"></div>
		</div>

		<div class="split">
			<div class="form-group">
				<label for="unit">Prix unitaire</label>
				<input type="text" class="form-control" id="unit" placeholder="Prix unitaire">
			</div>
			<div class="form-group">
				<label for="qtte">Quantité</label>
				<input type="text" class="form-control" id="qtte" placeholder="Quantité">
			</div>
		</div>
		<hr>
		{#if visutable}
		<table class="table">
			<tbody>
			{#each arrDesc as col, index}
				<tr>
					<td>{index}</td>
					<td>{@html col.desc}</td>
					<td>{col.unit}</td>
					<td>{col.qtte}</td>
					<td>{col.total}</td>
				</tr>
			{/each}
			</tbody>
		</table>
		{/if}
		<div class="split">
			<button on:click={handleAddColl}>Ajouter une ligne</button>
			<button on:click={handleeditline}>Éditer une ligne</button>
			<button on:click={handledeleteline}>Supprimer une ligne</button> 
			<button on:click={handleSee}>Visualiser</button> 
		</div>
		{/if}
		{/if}
		
	</div>
</div>
{#if editorstate === 1}
<hr>
{/if}
{#if editorstate === 50}
<button on:click={bAnnuleinvoicenew}>Annuler</button>
<hr>
<Calendar 
	events={[]}
	idents={[]}
	othersprops={[]}
	on:saveE
/>
{/if}
<div id="contentInvoice" style="margin: 20px auto;">


</div>